import React, { PureComponent, PropTypes } from 'react';
import Nav, { AkContainerItem, AkContainerHeader as NavHeader } from 'ak-navigation';
import { akColorN0 } from 'akutil-shared-styles';
import { Link } from 'react-router';
import { BASE_URL } from '../config';
import Footer from '../components/Footer';
import SearchDrawer from '../components/SearchDrawer';
import nucleusImg from '../images/nucleus.png';

import {
  AtlassianIcon,
  BitbucketDashboardIcon as DashboardIcon,
  BitbucketBranchesIcon as BranchesIcon,
  BitbucketRepositoriesIcon as ReposIcon,
  SearchIcon,
  ArrowleftIcon,
} from 'ak-icon';
import 'ak-css-reset';

const myLinks = [
  [`${BASE_URL}/`, 'Components', DashboardIcon],
  [`${BASE_URL}/metrics.html`, 'Metrics', ReposIcon],
  [`${BASE_URL}/dependencies.html`, 'Dependencies', BranchesIcon],
];

export default class App extends PureComponent {

  state = {
    isSearchDrawerOpen: false,
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          height: '100vh',
          overflowY: 'auto',
        }}
      >
        <style>{'body { margin: 0 }'}</style>
        <Nav
          containerHeader={
            <Link to="/">
              <NavHeader
                text="AtlasKit Registry"
                icon={<img alt="nucleus" src={nucleusImg} />}
              />
            </Link>
          }
          globalPrimaryIcon={
            <AtlassianIcon size="medium" label="Atlassian" />
          }
          globalSearchIcon={
            <span style={{ color: this.state.isSearchDrawerOpen ? akColorN0 : 'white' }}>
              <SearchIcon label="Search icon" />
            </span>
          }
          drawerBackIcon={<ArrowleftIcon label="Back icon" size="medium" />}
          isResizeable={false}
          hasBlanket
          isSearchDrawerOpen={this.state.isSearchDrawerOpen}
          onSearchDrawerOpen={() => {
            this.setState({ isSearchDrawerOpen: true });
            if (this.searchInputRef) {
              this.searchInputRef.focus();
            }
          }}
          onSearchDrawerClose={() => (this.setState({ isSearchDrawerOpen: false }))}
          searchDrawerContent={
            <SearchDrawer
              onResultClicked={() => (this.setState({ isSearchDrawerOpen: false }))}
              onSearchInputRef={(ref) => {
                this.searchInputRef = ref;
              }}
            />
          }
        >
          {
            myLinks.map(link => {
              const [url, title, Icon] = link;
              return (
                <Link key={url} to={url}>
                  <AkContainerItem
                    icon={<Icon label={title} />}
                    text={title}
                    isSelected={this.context.router.isActive(url, true)}
                  />
                </Link>
              );
            })
          }
        </Nav>

        <div style={{ margin: '32px 64px', flex: '1 1 auto' }}>
          {this.props.children}
          <Footer />
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/App.jsx